export const TOPBAR_STORAGE_KEY = 'abun_topbar_dismissed';
export const TOPBAR_HEIGHT = 44;

interface TopBarProps {
    onClose: () => void;
}

export default function TopBar({ onClose }: TopBarProps) {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: TOPBAR_HEIGHT + 'px',
            backgroundColor: '#f8b400',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            fontFamily: 'Geist, sans-serif',
            fontSize: '14px',
            fontWeight: 500,
            color: '#000',
        }}>
            <span>
                Try our other products:&nbsp;
                <a
                    href="https://draftss.com?via=abunapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#000', textDecoration: 'underline', fontWeight: 700 }}
                >
                    Draftss.com
                </a>
                &nbsp;&amp;&nbsp;
                <a
                    href="https://deliveryman.ai?via=abunapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#000', textDecoration: 'underline', fontWeight: 700 }}
                >
                    Deliveryman.ai
                </a>
            </span>
            <button
                onClick={onClose}
                style={{
                    position: 'absolute',
                    right: '1rem',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '20px',
                    lineHeight: 1,
                    padding: '4px 8px',
                    color: '#000',
                    fontWeight: 400,
                }}
                aria-label="Close announcement"
            >
                &times;
            </button>
        </div>
    );
}
